<template>
  <div id="sl-navbar">
    <header class="navbar">
      <template v-if="isSignedIn">
        <section class="navbar-section">
          <router-link to="/" @click.native="closeDrawers"><fa-icon icon="shopping-basket"></fa-icon></router-link>
        </section>
        <section class="navbar-section navbar-center" :class="{'d-none': hideSearch}" v-show="searchReady">
          <a href="#" @click.prevent="toggleSearch" :class="{'active': searchOpen}"><fa-icon icon="search" size="lg"></fa-icon></a>
        </section>
        <section class="navbar-section navbar-end navbar-hide-xs">
          <router-link to="/items" @click.native="closeDrawers"><fa-icon icon="book"></fa-icon></router-link>
          <router-link to="/meals" @click.native="closeDrawers"><fa-icon icon="utensils"></fa-icon></router-link>
          <router-link to="/setup" @click.native="closeDrawers"><fa-icon icon="sliders-h"></fa-icon></router-link>
          <a href="#" @click.prevent="signOut"><fa-icon icon="sign-out-alt"></fa-icon></a>
        </section>
        <section class="navbar-section navbar-end navbar-show-xs">
          <a href="#" @click.prevent="toggleMenu" :class="{'active': menuOpen}"><fa-icon icon="bars"></fa-icon></a>
        </section>
      </template>
      <template v-else>
        <section class="navbar-section"></section>
        <section class="navbar-section navbar-center">
          <a href="#" class="no-wrap">Shopping List</a>
        </section>
        <section class="navbar-section"></section>
      </template>
    </header>
    <template v-if="isSignedIn">
      <div class="sl-drawer sl-drop-menu" id="sl-navbar-dropmenu">
        <router-link to="/items" @click.native="closeDrawers"><fa-icon icon="book"></fa-icon></router-link>
        <router-link to="/meals" @click.native="closeDrawers"><fa-icon icon="utensils"></fa-icon></router-link>
        <router-link to="/setup" @click.native="closeDrawers"><fa-icon icon="sliders-h"></fa-icon></router-link>
        <a href="#" @click.prevent="signOut"><fa-icon icon="sign-out-alt"></fa-icon></a>
      </div>
      <div class="sl-drawer" id="sl-navbar-search">
        <div class="form-group">
          <div class="input-group">
            <input class="form-input" type="text" placeholder="Search..." v-model="searchText" ref="searchInput">
            <button class="btn btn-primary input-group-btn" @click.prevent="clearSearch"><fa-icon icon="times-circle" /></button>
          </div>
        </div>
        <div class="sl-search-results" v-if="searchResults.length || searchText">
          <template v-for="result in searchResults">
            <div @click="selectSearchResult(result)" :key="`${result.id}-category`" class="category label c-hand">{{result.category.name}}</div>
            <div @click="selectSearchResult(result)" :key="`${result.id}-desc`" class="desc c-hand" :class="{'needed': result.quantityNeeded, 'in-basket': result.isInCart}">
              <div class="name">{{ result.name }}</div>
              <div class="notes" v-if="result.notes">{{ result.notes }}</div>
            </div>
            <div @click="selectSearchResult(result)" :key="`${result.id}-stores`" class="stores c-hand">
              <span v-for="s in result.stores" :key="s.linkId" class="label label-rounded sl-store-label">{{ s.name }}</span>
            </div>
            <div @click="selectSearchResult(result)" :key="`${result.id}-status`" class="status c-hand">
              <fa-icon icon="shopping-basket" v-if="result.isInCart"></fa-icon>
              <fa-icon icon="clipboard-list" v-if="result.quantityNeeded && !result.isInCart"></fa-icon>
            </div>
          </template>
          <template>
            <div @click="newItemFromSearchText" class="category label is-new c-hand">New!</div>
            <div @click="newItemFromSearchText" class="desc c-hand">
              <div class="name">{{ searchText }}</div>
              <div class="notes">Tap to add this item</div>
            </div>
            <div @click="newItemFromSearchText" class="stores c-hand"></div>
            <div @click="newItemFromSearchText" class="status c-hand">
              <fa-icon icon="plus-circle"></fa-icon>
            </div>
          </template>
        </div>
      </div>
      <div class="sl-mask" :class="{'d-none': !anyDrawerOpen}" @click="closeDrawers"></div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'NavBar',
  data () {
    return {
      searchOpen: false,
      menuOpen: false,
      hideSearch: !this.$route.meta.showSearch,
      searchText: '',
      searchResults: []
    }
  },
  computed: {
    searchReady () {
      return this.itemsAreLoaded && this.categoriesAreLoaded
    },
    anyDrawerOpen () {
      return this.searchOpen || this.menuOpen
    }
  },
  created () {
    this.debouncedSearch = _.debounce(this.doSearch, 300)
  },
  methods: {
    doSearch () {
      const sText = (this.searchText || '').trim()
      if (sText.length < 3) {
        this.searchResults = []
        return
      }
      this.searchResults = this.searchItems(sText)
    },
    clearSearch () {
      this.searchText = ''
      this.searchResults = []
      this.$refs['searchInput'].focus()
    },
    selectSearchResult (item) {
      if (!item.isInCart && !item.quantityNeeded) {
        this.setItemQuantityNeeded({ id: item.id, quantityNeeded: 1 })
      }
      this.closeDrawers()
    },
    newItemFromSearchText () {
      const newItemName = `${this.searchText.trim().toLowerCase()}`
      this.closeDrawers()
      console.log(`Creating: ${newItemName}`)
      this.$router.push({ name: 'item-create', params: { newItemName, fromRouteName: 'home' } })
    },
    closeDrawers () {
      if (this.menuOpen) {
        this.toggleMenu()
      }
      if (this.searchOpen) {
        this.toggleSearch()
      }
    },
    toggleSearch () {
      if (this.menuOpen) {
        this.toggleMenu()
      }
      const searchDrawer = document.getElementById('sl-navbar-search')
      if (this.searchOpen) {
        searchDrawer.classList.remove('open')
        this.searchText = ''
        this.searchResults = []
      } else {
        searchDrawer.classList.add('open')
        this.$refs['searchInput'].focus()
      }
      this.searchOpen = !this.searchOpen
    },
    toggleMenu () {
      if (this.searchOpen) {
        this.toggleSearch()
      }
      const menuDrawer = document.getElementById('sl-navbar-dropmenu')
      if (this.menuOpen) {
        menuDrawer.classList.remove('open')
      } else {
        menuDrawer.classList.add('open')
      }
      this.menuOpen = !this.menuOpen
    }
  },
  watch: {
    '$route' () {
      this.hideSearch = !this.$route.meta.showSearch
    },
    searchText () {
      this.debouncedSearch()
    }
  }
}
</script>

<style lang="scss">
  @import '../assets/_vars';

  #sl-navbar {
    background-color: $darkest-color;
    height: $navbar-height;
    top: 0;
    left: 0;
    right: 0;
    position: fixed;
    z-index: 100;

    header {
      height: $navbar-height;
      width: 100%;
      z-index: 1;

      .navbar-section {
        align-items: stretch;

        &.navbar-end {
          justify-content: flex-end;
        }

        &.navbar-show-xs {
          @media (max-width: 480px) {
            display: flex;
          }
          @media (min-width: 481px) {
            display: none;
          }
        }
        &.navbar-hide-xs {
          @media (max-width: 480px) {
            display: none;
          }
          @media (min-width: 481px) {
            display: flex;
          }
        }

        a {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 3em;
          font-size: 1rem;
          text-align: center;
          color: $primary-color;

          &.router-link-exact-active, &.active {
            color: $body-font-color;
          }
        }
      }
    }

    .sl-mask {
      position: absolute;
      top: $navbar-height;
      left: 0;
      right: 0;
      bottom: 0;
      height: calc(100vh - (0.8 * #{$navbar-height}));
      width: 100%;
      z-index: -3;
      background-color: black;
      opacity: 0.5;
    }

    .sl-drawer {
      position: absolute;
      top: $navbar-height;
      left: 2%;
      right: 2%;
      margin: 0 auto;
      padding: 0.5rem;
      background-color: $darkest-color;
      box-shadow: inset 0 -1px 1px $primary-color, 0 6px 12px rgba(0,0,0,0.5);
      border-radius: 0 0 0.5rem 0.5rem;
      z-index: -2;
      transition: all 100ms ease-in;
      transform: translateY(-100%);
      opacity: 0;

      @media (min-width: $size-xs) {
        left: 5%;
        right: 5%;
      }

      @media (min-width: $size-md) {
        left: 15%;
        right: 15%;
      }

      @media (min-width: $size-lg) {
        left: 20%;
        right: 20%;
      }

      &.open {
        transform: none;
        opacity: 1;
        transition: all 200ms ease-out;
      }

      &.sl-drop-menu {
        display: flex;
        justify-content: space-evenly;

        a {
          color: $primary-color;

          &.router-link-exact-active {
            color: $body-font-color;
          }
        }
      }
    }

    #sl-navbar-search {
      &:focus-within {
        .sl-search-results {
          max-height: 20vh;
          transition: max-height 150ms ease-in-out;
        }
      }
    }

    .sl-search-results {
      max-height: 60vh;
      transition: max-height 300ms ease-in-out;
      overflow-y: auto;
      width: 100%;
      display: grid;
      grid-template-columns: min-content 1fr min-content 2rem;
      grid-auto-rows: minmax(min-content, 1.75rem);
      grid-column-gap: 0.4rem;
      grid-row-gap: 0.5rem;

      // Oveflow shadows:
      background:
        // Shadow covers
        linear-gradient($darkest-color 30%, fade_out($darkest-color, 1)),
        linear-gradient(fade_out($darkest-color, 1), $darkest-color 70%) 0 100%,
        // Shadows
        radial-gradient(farthest-side at 50% 0, rgba(0,0,0,.3), rgba(0,0,0,0)),
        radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.3), rgba(0,0,0,0)) 0 100%;
      background:
        // Shadow covers
        linear-gradient($darkest-color 30%, fade_out($darkest-color, 1)),
        linear-gradient(fade_out($darkest-color, 1), $darkest-color 70%) 0 100%,
        // Shadows
        radial-gradient(farthest-side at 50% 0, rgba(0,0,0,.3), rgba(0,0,0,0)),
        radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.3), rgba(0,0,0,0)) 0 100%;
      background-repeat: no-repeat;
      background-color: $darkest-color;
      background-size: 100% 2rem, 100% 2rem, 100% 1rem, 100% 1rem;
      background-attachment: local, local, scroll, scroll;

      @media (max-width: $size-xs) {
        grid-template-columns: min-content 1fr 2rem;
      }
      @media (max-width: $size-sm) {
        max-height: calc(100vh - (2.5 *#{$navbar-height}));
      }

      .category {
        align-self: stretch;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 0.4rem;
        background-color: lighten($darkest-color, 10%);
        text-align: right;

        &.is-new {
          background-color: $success-color;
        }
      }

      .desc {
        align-self: center;
        .name {
          line-height: 1.1rem;
        }
        .notes {
          font-size: 0.8rem;
          line-height: 1.0rem;
          font-style: italic;
          color: lighten($dark-color, 20%);
        }
      }

      .stores {
        align-self: center;

        @media (max-width: $size-xs) {
          display: none;
        }
      }

      .status {
        color: lighten($dark-color, 30%);
        align-self: center;
        text-align: center;
      }
    }
  }
</style>
